export default __webpack_public_path__ + "static/media/intellij.11b68713.png";